import InfoDialog from './InfoDialog'

export { InfoDialog }
export default InfoDialog
